import React from "react";
import { render } from "react-dom";
import { createInertiaApp } from "@inertiajs/inertia-react";
import { InertiaProgress } from "@inertiajs/progress";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

require("./bootstrap");

InertiaProgress.init();

Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.2,
    enabled: process.env.NODE_ENV !== "development",
});

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, App, props }) {
        render(<App {...props} />, el);
    },
});
